





















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SelectTemplateDisplay extends Vue
{
	@Prop() template!: PublishedTemplate
	@Prop({ default: false }) canCancel!: boolean
}
